import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | undefined = undefined;

export const initializeAppInsights = (): ApplicationInsights => {
  const shouldntSendTelemetry = process.env.NODE_ENV === "development";
  const key = window.config.aiInstrumentationKey;
  appInsights = new ApplicationInsights({
    config: {
      connectionString: key,
      enableRequestHeaderTracking: true,
      disableAjaxTracking: true,
      disableTelemetry: shouldntSendTelemetry,
      disableExceptionTracking: false,
      enableAutoRouteTracking: true,
      disableFetchTracking: true, // Only interested in faulty requests
      enableAjaxErrorStatusText: true,
      loggingLevelTelemetry: 2,
      loggingLevelConsole: 2,
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
  return appInsights;
};

export const getAppInsights = (): ApplicationInsights => {
  if (!appInsights)
    throw new Error("App Insights was not initialized correctly");
  return appInsights;
};
